import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkmark",
  "use": "checkmark-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"checkmark\"><path d=\"M8.205 15.011a.83.83 0 0 1-.607-.266l-4.04-4.297a.832.832 0 0 1 1.214-1.14l3.425 3.65 6.99-7.647a.832.832 0 1 1 1.23 1.114L8.82 14.737a.83.83 0 0 1-.607.274z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol